import React from 'react';

const HostInfo = ({title, text, items,Illustration,video,reverse=false}) => {
	return (
		<div className='host-info'>
			<div className={`host-info-wrap ${reverse ? 'reverse' : ''}`}>
				<div className='host-info-img'>
					{/*<Illustration/>*/}
					<video key={Math.random()} autoPlay playsInline muted loop>
						<source src={video} type="video/mp4" />
						Your browser does not support HTML video.
					</video>
				</div>
				<div className='host-info-txt'>
					<h3>{title}</h3>
					<p>
						{text}
					</p>
				</div>
			</div>
			<div className='host-info-list'>
				<ul>
					{items.map((item, key) => {
							const Icon = item.icon
							return (<li key={key}>
								<div className={`hi-list-item ${item.className}`}>
									<Icon/>
									<h4>{item.text}</h4>
								</div>
							</li>)
						}
					)}
				</ul>
			</div>
		</div>
	)
}

export default HostInfo;